import { CrossIcon } from '../../assets/images/images';

const CustomCloseButton = ({ closeToast }: any) => {
    return (
        <button
            onClick={closeToast}
            className='toast-close-btn'
        >
            <img src={CrossIcon} alt="button" className="cross-icon" />
        </button>
    );
};

export default CustomCloseButton;
